import React from 'react';
import PropTypes from 'prop-types';
import { customerInfo as customerInfoShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import { StyledTableRow, StyledTableHeader, StyledTableCell } from '../ClubEurostarMember.styles';

const PointsSummaryRow = ({
  summaryType,
  nextQualifyingPointsResetDate,
  pointsBalance,
  totalPointsAccrued,
  totalPointsExpired,
  totalPointsRedeemed
}) => (
  <StyledTableRow data-testid={`user-points-summary-row-${summaryType}`} columns={6}>
    <StyledTableCell span={1} data-testid={`user-points-summary-row-${summaryType}-summary-type`}>
      <FormattedMessage id={summaryType} tagName="strong" />
    </StyledTableCell>
    <StyledTableCell span={1} justifyContent="center" data-testid={`user-points-summary-row-${summaryType}-points-balance`}>
      {pointsBalance}
    </StyledTableCell>
    <StyledTableCell span={1} justifyContent="center" data-testid={`user-points-summary-row-${summaryType}-total-points-accrued`}>
      {totalPointsAccrued}
    </StyledTableCell>
    <StyledTableCell span={1} justifyContent="center" data-testid={`user-points-summary-row-${summaryType}-total-points-redeemed`}>
      {totalPointsRedeemed}
    </StyledTableCell>
    <StyledTableCell span={1} justifyContent="center" data-testid={`user-points-summary-row-${summaryType}-total-points-expired`}>
      {totalPointsExpired}
    </StyledTableCell>
    <StyledTableCell
      span={1}
      justifyContent="center"
      data-testid={`user-points-summary-row-${summaryType}-next-qualifying-points-reset-date`}
    >
      {nextQualifyingPointsResetDate ? moment(nextQualifyingPointsResetDate).format('DD-MMM-YYYY') : '-'}
    </StyledTableCell>
  </StyledTableRow>
);

PointsSummaryRow.propTypes = {
  summaryType: PropTypes.string,
  nextQualifyingPointsResetDate: PropTypes.string,
  pointsBalance: PropTypes.number,
  totalPointsAccrued: PropTypes.number,
  totalPointsExpired: PropTypes.number,
  totalPointsRedeemed: PropTypes.number
};

const PointsSummaryTable = ({ customerInfo }) => {
  const loyalty = customerInfo?.profile?.loyalty;

  if (!loyalty) {
    return null;
  }

  const { statusPointsSummary, rewardPointsSummary } = loyalty;

  return (
    <div data-testid="user-points-summary">
      <StyledTableRow columns={6}>
        <StyledTableHeader span={1} justifyContent="center" />
        <StyledTableHeader span={1} justifyContent="center">
          <FormattedMessage id="clubEurostar.pointsBalance" tagName="strong" />
        </StyledTableHeader>
        <StyledTableHeader span={1} justifyContent="center">
          <FormattedMessage id="clubEurostar.totalPointsAccrued" tagName="strong" />
        </StyledTableHeader>
        <StyledTableHeader span={1} justifyContent="center">
          <FormattedMessage id="clubEurostar.totalPointsRedeemed" tagName="strong" />
        </StyledTableHeader>
        <StyledTableHeader span={1} justifyContent="center">
          <FormattedMessage id="clubEurostar.totalPointsExpired" tagName="strong" />
        </StyledTableHeader>
        <StyledTableHeader span={1} justifyContent="center">
          <FormattedMessage id="clubEurostar.nextResetDate" tagName="strong" />
        </StyledTableHeader>
      </StyledTableRow>
      <PointsSummaryRow summaryType="clubEurostar.statusPoints" {...statusPointsSummary} />
      <PointsSummaryRow summaryType="clubEurostar.points" {...rewardPointsSummary} />
    </div>
  );
};

PointsSummaryTable.propTypes = {
  customerInfo: customerInfoShape
};

export default PointsSummaryTable;
